import { AlertTriangle, Info } from "lucide-react";
import { minOrderNoticeText, type MinOrderAmountNotice as Notice } from "../utils/minOrderAmount";

/**
 * Pasek „kwota minimalna zamówienia z umowy ramowej”. Gdy umowa ma minimum, pokazywany
 * ZAWSZE: neutralnie, gdy wartość je spełnia, bursztynowo (ostrzeżenie), gdy jest niższa.
 * Informacja, nie blokada — przy proponowaniu podwykonawcy (formularz zapotrzebowania),
 * w szczegółach zapotrzebowania, w oknie zatwierdzania i na zamówieniu.
 */
export function MinOrderAmountNotice({ notice, className = "" }: { notice: Notice | null | undefined; className?: string }) {
  if (!notice) return null;
  const warning = notice.below_minimum;
  return (
    <div
      role="status"
      data-testid="min-order-amount-notice"
      data-below-minimum={warning ? "true" : "false"}
      className={`flex items-start gap-2 rounded border px-3 py-2 text-xs ${
        warning
          ? "border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-300"
          : "border-blue-200 bg-blue-50 text-blue-800 dark:border-blue-800 dark:bg-blue-900/20 dark:text-blue-300"
      } ${className}`}
    >
      {warning ? <AlertTriangle size={14} className="mt-0.5 shrink-0" /> : <Info size={14} className="mt-0.5 shrink-0" />}
      <span>{minOrderNoticeText(notice)}</span>
    </div>
  );
}
